import { RackOptions } from '../../../RackTypes'
import { RACK_COLORS } from '../../../constants'
import { getBarConfig } from '../../bar/getBarConfig'
import { getAccessoryQuantity, findBundleProduct } from '../../../utils/product-lookup'
import { getHardwareSelection, getFrontSelection, getJCupSelection, getSafetySelection, getBenchSelection, getPlateSelection } from '../../../utils/selection-utils'
import { FlatFootBuilder } from './flatFootBuilder'
import { getBuyRequestMeta, getSimpleForBuyRequest } from '@/js/helpers/buy-request'
import { IRogue, BuyRequest } from '@/js/services/RogueTypes'

// Creates RM/RML 390F
export function createFlatFootRackConfig(rogue: IRogue, buyRequest: BuyRequest): RackOptions {
  const meta = getBuyRequestMeta(buyRequest, rogue)
  const rack = getSimpleForBuyRequest(buyRequest, rogue)
  const line = rack?.name?.includes('RML') ? 'RML' : 'RM'

  const color = RACK_COLORS[(rack?.attributes?.rig_color as string) || 'Satin Black']
  const strapSafetyAccessory = Boolean(getAccessoryQuantity(rogue, buyRequest, 'strap safety'))
  const bar = findBundleProduct(rogue, buyRequest, 'Add a bar', true)

  const config: RackOptions =  {
    line,
    depth       : '4',
    color,
    hardware    : getHardwareSelection(rogue, buyRequest),
    front       : getFrontSelection(rogue, buyRequest, meta),
    jcup        : getJCupSelection(rogue, buyRequest, true),
    safeties    : getSafetySelection(rogue, buyRequest, meta, strapSafetyAccessory),
    bar         : bar ? getBarConfig(rogue, bar) : undefined,
    bench       : getBenchSelection(rogue, buyRequest),
    plates      : getPlateSelection(rogue, buyRequest),
    accessories : [],
  }

  return config
}

export function createFlatFootRack(rogue: IRogue, buyRequest: BuyRequest) {
  const config = createFlatFootRackConfig(rogue, buyRequest) 
  const part = new FlatFootBuilder(config).build() // No factory needed for this product
  
  return { config, part }
}
